<template>
    <b-datatable
        :key="datatableKey"
        ref="dataTable"
        :columns="columns"
        :endpoint="listRoute"
        :hidden-columns="hiddenColumns"
        :initial-filters="initialFilters"
        :initial-sort="initialSort"
        :grid-title="t('patients::grid.title.adverse_events')"
        has-filter-selector
        item-key="id"
    >
        <template #filters="{ filters }">
            <v-col cols="4">
                <b-filter-select
                    v-model="filters.filters.event_type"
                    :label="t('patients::filters.label.event_type')"
                    :items="filtersOptions.eventType"
                    :clearable="filters.filters.event_type !== null"
                ></b-filter-select>
            </v-col>
            <v-col cols="4">
                <b-filter-date
                    v-model="filters.filters.filter_event_date"
                    range
                    :label="t('patients::filters.label.event_date')"
                    @clear="onCloseDateFilter(filters, 'filter_event_date')"
                ></b-filter-date>
            </v-col>
        </template>
        <template #[`item.event_date`]="{ item }">
            {{ item.event_date ? moment(item.event_date).format($root.dateFormat) : t('default::label.na') }}
        </template>
        <template #[`item.event_type`]="{ item }">
            <div class="grid-status">
                <span> {{ t(`patients::options.event_type.${item.event_type}`) }} </span>
            </div>
        </template>
        <template #[`item.actions`]="{ item }">
            <div class="table-actions">
                <v-tooltip v-if="can('api.v1.patients.adverse-events.update')" top transition="v-fab-transition">
                    <template #activator="{ on, attrs }">
                        <v-btn color="disabled-color" icon v-bind="attrs" v-on="on" @click="editItemUrl(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ t('patients::button.edit_form') }}</span>
                </v-tooltip>
                <v-tooltip
                    v-if="!can('api.v1.patients.adverse-events.update') && can('api.v1.patients.adverse-events.show')"
                    top
                    transition="v-fab-transition"
                >
                    <template #activator="{ on, attrs }">
                        <v-btn color="disabled-color" icon v-bind="attrs" v-on="on" @click="editItemUrl(item)">
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ t('patients::button.preview') }}</span>
                </v-tooltip>
                <v-tooltip v-if="can('adverse-events.download') && item.pdf_data.id" top transition="v-fab-transition">
                    <template #activator="{ on, attrs }">
                        <v-btn color="disabled-color" icon v-bind="attrs" v-on="on" @click="downloadPdf(item)">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ t('patients::button.download_pdf') }}</span>
                </v-tooltip>
            </div>
        </template>
    </b-datatable>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            datatableKey: 0,
            downloadingFile: false,
            columns: [
                {
                    text: t('default::grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('patients::grid.label.date_of_adverse_event'),
                    value: 'event_date',
                    sortable: true,
                    width: 200,
                },
                {
                    text: t('patients::grid.label.event_type'),
                    value: 'event_type',
                    sortable: true,
                    width: 170,
                },
                {
                    text: t('patients::grid.label.actions'),
                    value: 'actions',
                    sortable: false,
                    fields: 'patient_id,pdf_data.id',
                    align: 'end',
                    width: 150,
                },
            ],
            hiddenColumns: ['id'],
            initialFilters: {
                event_type: null,
            },
            initialSort: '',
            filtersOptions: {
                eventType: [],
            },
        };
    },
    computed: {
        tab() {
            return this.$store.state.patients.tab;
        },
        patient() {
            return this.$store.state.patients.patient;
        },

        patientId() {
            return this.$store.state.patients.patient.id;
        },
    },
    watch: {
        tab(val) {
            if (val === 6) {
                this.$refs.dataTable.resetTable();
            }
        },
    },

    mounted() {
        this.loadOptions();
    },
    methods: {
        loadOptions() {
            return axios.get(route('api.v1.adverse-events.config')).then((response) => {
                const data = _.clone(response.data.adverse_events);
                this.filtersOptions.eventType = _.union(
                    [
                        {
                            text: t('patients::status.all'),
                            value: null,
                        },
                    ],
                    data.adverse_event_types
                );
            });
        },
        editItemUrl(item) {
            this.$store.dispatch('patients/changeTab', 6);
            this.$store.dispatch('adverse_event/loadAdverseEvent', item);
        },
        downloadPdf(item) {
            if (this.downloadingFile) {
                return;
            }

            this.downloadingFile = true;

            axios
                .get(route('adverse-events.download', { pdf: item.id }))
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = response.request.responseURL;
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                })
                .finally(() => {
                    _.delay(() => {
                        this.downloadingFile = false;
                    }, 2000);
                });
        },

        onCloseDateFilter(filters, filter) {
            switch (filter) {
                case 'filter_event_date':
                    filters.filters.event_date = null;
                    filters.filters.filter_event_date = null;
                    break;
                default:
                    break;
            }
        },
    },
};
</script>

<style></style>
